import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService, IEventType } from '@df/core/service/df-event';
import { Gtm } from '@df/module-gtm/event/gtm.event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import isEmpty from 'lodash-es/isEmpty';
import pickBy from 'lodash-es/pickBy';
import './gtm-event-view-item-list';

@Injectable({
    providedIn: 'root'
})
export class GtmEventViewItemListTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'dfGtmItemListView') {
                this.dispatch(event, event.data);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, data: IEventType['dfGtmItemListView']['data']) {
        const eventData: Gtm.Ecommerce.ListContent = {
            ...(await this.gtmDataService.getEventData(data.items)),
            item_list_id: data.listId,
            item_list_name: data.listName
        };

        if ('filters' in data) {
            eventData['item_list_filters'] = pickBy(data.filters, filter => !isEmpty(filter));
            eventData['item_list_sort'] = data.sort;
        }

        return this.gtmService.dispatch({
            event: 'view_item_list',
            ecommerce: eventData,
            triggerContext: {
                trigger
            }
        });
    }
}
